import React from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';

const emptyFilters = { id: '', name: '', category: '', brand: '', priceMin: '', priceMax: '', status: '' };

const ProductTableFilters = ({ filters, onChange, onClear, isMobile }) => {
  const handle = (field) => (e) => {
    onChange({ [field]: e.target.value });
  };

  const clearAll = () => {
    onClear ? onClear() : onChange(emptyFilters);
  };

  return (
    <fieldset className='filters-bar'>
      <legend className='filters-bar__legend mb-2'>Filters</legend>
      <Form>
        <Row className='g-2'>
          <Col xs={6} md={2}>
            <Form.Control size='sm' placeholder='ID' value={filters.id} onChange={handle('id')} />
          </Col>
          <Col xs={6} md={3}>
            <Form.Control size='sm' placeholder='Name' value={filters.name} onChange={handle('name')} />
          </Col>
          <Col xs={6} md={2}>
            <Form.Control size='sm' placeholder='Category' value={filters.category} onChange={handle('category')} />
          </Col>
          <Col xs={6} md={2}>
            <Form.Control size='sm' placeholder='Brand' value={filters.brand} onChange={handle('brand')} />
          </Col>
          <Col xs={6} md={2}>
            <Form.Control as='select' size='sm' value={filters.status} onChange={handle('status')}>
              <option value=''>Status: All</option>
              <option value='enabled'>Status: Enabled</option>
              <option value='disabled'>Status: Disabled</option>
            </Form.Control>
          </Col>
          <Col xs={6} md={1}>
            <Form.Control size='sm' type='number' placeholder='Min $' value={filters.priceMin} onChange={handle('priceMin')} />
          </Col>
          <Col xs={6} md={1}>
            <Form.Control size='sm' type='number' placeholder='Max $' value={filters.priceMax} onChange={handle('priceMax')} />
          </Col>
          <Col xs={12} md={1} className='d-flex'>
            <Button variant='outline-secondary' size='sm' className='w-100' onClick={clearAll} type='button'>Clear</Button>
          </Col>
        </Row>
      </Form>
    </fieldset>
  );
};

export default ProductTableFilters;
